import { get } from "lodash";

const SelectInputForm = ({
  id,
  label,
  isRequired,
  formik,
  options,
  valueAsNumber,
  selectedBy,
  displayedText,
  serverError,
  parentClassName,
  labelClassName,
  parentInputClassName,
  sideEffect,
}) => {
  const errorMessage = get(formik.errors, id);
  const serverErrorMessage = get(serverError, id);
  const defaultValue = get(formik.values, id);
  const touched = get(formik.touched, id);
  return (
    <div className={`form-group ${parentClassName}`}>
      <label htmlFor={id} className={`field-label mb-2 ${labelClassName}`}>
        {label}&nbsp;
        {isRequired && <span className="text-red-600">*</span>}
      </label>
      <div className={`w-full ${parentInputClassName}`}>
        <select
          name={id}
          id={id}
          className="form-control"
          onChange={(e) => {
            if (valueAsNumber) {
              formik.setFieldValue(id, parseInt(e.target.value));
            } else {
              formik.setFieldValue(id, e.target.value);
            }
            typeof sideEffect === "function" && sideEffect(e);
          }}
          onBlur={formik.handleBlur}
          value={defaultValue || ""}
        >
          <option value="">Select {label}</option>
          {options?.map((option) => {
            if (
              typeof option === "string" ||
              option instanceof String ||
              typeof option === "number" ||
              option instanceof Number
            ) {
              return (
                <option key={option} value={option}>
                  {option}
                </option>
              );
            }
            return (
              <option key={option[selectedBy]} value={option[selectedBy]}>
                {option[displayedText]}
              </option>
            );
          })}
        </select>
        {((touched && errorMessage) || errorMessage) && (
          <div className="help-block text-red-400 mt-2">{errorMessage}</div>
        )}
        {serverErrorMessage && (
          <div className="help-block text-red-400 mt-2">
            {serverErrorMessage}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectInputForm;
